<template>
    <div class="w3-container w3-white w3-margin-bottom zero-top w3-animate-opacity content-sidebars sidebars-20-80">
        <div class="w3-col content-sidebar-left w3-padding">
            <div class="w3-center zero-left zero-right">
                <h4 class="flow-blue-color w3-margin-bottom">{{ $t("searchBeforeAdd") }}</h4>
                <button v-if="this.$route.name==='search_add_new_patient'"
                        class="flow-btn w3-btn w3-ripple w3-round w3-text-white font-weight-bold w3-large"
                        @click.prevent="onClose">
                    <i class="fa fa-search flow-green-active-color">
                        <span class="flow-margin-left"><b class="flow-margin-left">{{ $t("search") }}</b></span>
                    </i>
                </button>
                <router-link v-else
                             :to="{ name: 'search_add_new_patient'}"
                             class="flow-btn w3-btn w3-ripple w3-round w3-text-white font-weight-bold w3-large">
                    <i class="fa fa-search flow-green-active-color">
                        <span class="flow-margin-left"><b class="flow-margin-left">{{ $t("search") }}</b></span>
                    </i>
                </router-link>
            </div>
        </div>


        <div class="w3-col content-sidebar-right top-from-header w3-animate-right">
            <i class="fa fa-times w3-xlarge w3-text-gray cursor-pointer card-closer flow-padding-top w3-left" @click="onClose"></i>
            <h4 class="flow-blue-color w3-left zero-left flow-margin-top-3-pct">
                <i class="fa fa-user-plus w3-margin-right"></i>
                <b>{{ $t("addNewPatient") }}</b>
            </h4>
            <div>
                <new-patient-card class="w-90pc flow-margin-auto" :onClose="onClose" :isFastTrackForm="isFastTrackForm"></new-patient-card>
            </div>
        </div>

    </div>
</template>

<script>
    import NewPatientCard from "./NewPatientCard";
    export default {
        name: "NewPatientMainCard",
        components: {NewPatientCard},
        props: ['onClose', 'isFastTrackForm']
    }
</script>

<style scoped>

</style>